import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { BriefApplicationResponseDto, BriefResponseDto } from '@/app/common/general-types/briefs.dto';
import { CreatorResponseDto } from '@/app/common/general-types/creators.dto';
import { PayoutDto } from '@/app/common/general-types/payouts.dto';
import { WalletTransactionResponseDto } from '@/app/common/general-types/wallet-transaction.dto';

@Injectable({
  providedIn: 'root',
})
export class AdminPayoutTraceService {
  private http = inject(HttpClient);

  getCreator(creatorId: string): Observable<CreatorResponseDto> {
    const url = `${environment.shout_api.url}/creators/${creatorId}`;
    return this.http.get<CreatorResponseDto>(url);
  }

  getBrief(briefId: string): Observable<BriefResponseDto> {
    const url = `${environment.shout_api.url}/briefs/${briefId}`;
    return this.http.get<BriefResponseDto>(url);
  }

  getBriefApplication(briefId: string, creatorId: string): Observable<BriefApplicationResponseDto | null> {
    const url = `${environment.shout_api.url}/brief-application/student-application/${briefId}/${creatorId}`;
    return this.http.get<BriefApplicationResponseDto | null>(url);
  }

  getWalletTransactionByBriefApplicationId(
    briefApplicationId: string,
  ): Observable<WalletTransactionResponseDto | null> {
    const url = `${environment.shout_api.url}/wallet-transactions/by-brief-application/${briefApplicationId}`;
    return this.http.get<WalletTransactionResponseDto | null>(url);
  }

  getPayoutByWalletTransactionId(walletTransactionId: string): Observable<PayoutDto | null> {
    const url = `${environment.shout_api.url}/payouts/by-wallet-transaction/${walletTransactionId}`;
    return this.http.get<PayoutDto | null>(url);
  }

  getPayoutById(payoutId: string): Observable<PayoutDto | null> {
    const url = `${environment.shout_api.url}/payouts/${payoutId}`;
    return this.http.get<PayoutDto | null>(url);
  }
}
